import React, {useEffect, useState} from 'react';
import propTypes from 'prop-types';
import styled from '@emotion/styled';
import {Grid, Box, Typography} from '@mui/material';
import {gql} from '@apollo/client';
import {get} from 'lodash';
// withWidth removed - use useMediaQuery instead;

import HeartSvg from '../../../assets/icons/heart.svg';
import HeartFilledSvg from '../../../assets/icons/heartFilled.svg';

import jaycoClient from '../../../graphql/jaycoClient';

import toPrice from '../../../util/toPrice';
import {theme} from '../../../themes/default-theme';

import RespImg from '../../../components/ui/RespImg';
import Text from '../../../components/typography';
import Dropdown from '../../../components/ui/Dropdown';
import SleepKey from '../../../components/ui/SleepKey'
import Links from '../../../components/ui/Links';
import NextLink from '../../navigation/NextLink';

const Container = styled.div`
  max-width: 400px;

  .key-container {
    margin-bottom: 0;
  }

  .key-item {
    padding-left: 24px;
    padding-right: 8px;
    margin-right: 0;
    &:before {
      left: 8px;
    }

    ${theme.breakpoints.only('sm')} {
      margin-right: 0;
    }

    ${theme.breakpoints.up('md')} {
      padding-left: 32px;
      padding-right: 16px;
      &:before {
        left: 16px;
      }
    }
  }

  h6 {
    min-height: 41px;
    ${theme.breakpoints.up('md')} {
      min-height: 42px;
    }
    ${theme.breakpoints.up('lg')} {
      min-height: 52px;
    }
  }
`

const ImgContainer = styled.div`
  position: relative;
  display: flex;
  align-items: center;

  ${theme.breakpoints.down('sm')} {
    margin-bottom: 20px;
  }

  picture {
    padding: 5px 0;
    position: relative;
    z-index: 2;

    ${theme.breakpoints.up('md')} {
      padding: 25px 30px;
    }
  }

`

const Filters = styled.div`
  select {
    padding-right: 45px !important;
    
  }
`

const FilterItem = styled.div`
  margin: 20px 0;
`

const Price = styled.div`
  ${props => props.opacity === 1 && `
    opacity: 0.5;
  `}

  h3 {
    letter-spacing: 0;
  }

  span {
    font-size: 80%;
    vertical-align: top;
  }
`

const Footer = styled.div`
  min-height: 52px;

  ${theme.breakpoints.up('md')} {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  svg {
    [fill] {
      fill: white
    }
    ${theme.breakpoints.down('md')} {
      max-height: 8px;
      top: -3px;
      position: relative;
    }
  }
`

const Buttons = styled.div`
  margin-top: 15px;

  ${theme.breakpoints.up('md')} {
    margin-top: 0;
    display: flex;
  }
`

const ButtonItem = styled.div`
  margin-right: 12px;
  margin-top: 10px;
  cursor: pointer;
  ${theme.breakpoints.up('md')} {
    margin-left: 12px;
    margin-top: 0;
    margin-right: 0;
  }
`

const Content = styled.div`
    ${props => props.padding === 1 ? `
      padding: 8px 8px 40px;
    ` : 
      `padding: 0 8px;
    `
    }
  ${theme.breakpoints.up('md')} {

    ${props => props.padding === 1 ? `
      padding: 0 16px 40px;
    ` : `
      padding: 0 16px;
    `}
    
  }
`

const caravanFilterDefaultPropOnClear = () => {};
const caravanFilterDefaultPropOnSave = () => {};
const caravanFilterDefaultPropOnChange = () => {};

const CaravanFilter = (props) => {
  props = {
    ...props,
    title: typeof props.title === "undefined" ? null : props.title,
    image: typeof props.image === "undefined" ? null : props.image,
    filters: typeof props.filters === "undefined" ? null : props.filters,
    sleepsStandard: typeof props.sleepsStandard === "undefined" ? null : props.sleepsStandard,
    sleepsOptional: typeof props.sleepsOptional === "undefined" ? null : props.sleepsOptional,
    price: typeof props.price === "undefined" ? null : props.price,
    saved: typeof props.saved === "undefined" ? null : props.saved,
    onClear: typeof props.onClear === "undefined" ? caravanFilterDefaultPropOnClear : props.onClear,
    onSave: typeof props.onSave === "undefined" ? caravanFilterDefaultPropOnSave : props.onSave,
    onChange: typeof props.onChange === "undefined" ? caravanFilterDefaultPropOnChange : props.onChange,
    getPrice: typeof props.getPrice === "undefined" ? true : props.getPrice,
    layoutId: typeof props.layoutId === "undefined" ? null : props.layoutId,
    hideImgMobile: typeof props.hideImgMobile === "undefined" ? false : props.hideImgMobile,
    uri: typeof props.uri === "undefined" ? null : props.uri,
    pricingKey: typeof props.pricingKey === "undefined" ? null : props.pricingKey
  };

  const {
    title,
    image,
    filters,
    sleepsStandard,
    sleepsOptional,
    price,
    saved,
    onClear,
    onSave,
    onChange,
    layoutId,
    getPrice,
    hideImgMobile,
    uri,
    pricingKey
  } = props;

  const [apiPrice, setApiPrice] = useState(null);
  const [loading, setLoading] = useState(false);


  useEffect(() => {
    const getModelPrice = async () => {

      const GET_MODEL_DATA = gql`
        query GetModel($id: ID!) {
          getModel(id: $id) {
            id
            priceAU
            priceAUNSW
            priceAUACT
            priceAUVIC
            priceAUQLD
            priceAUSA
            priceAUWA
            priceAUTAS
            priceAUNT
            priceNZ
          }
        }
      `
      setLoading(true);


      var priceKey;

      if (process.env.STATICLY_DEPLOYMENT_DESTINATION_DOMAIN.indexOf('jayco.com.au') !== -1 || window.location.hostname.indexOf('com-au') !== -1 || window.location.hostname.indexOf('com.au') !== -1) {
        // priceKey = 'priceAUNSW'
      } else {
        priceKey = 'priceNZ'
      }

      // override if in props
      if (pricingKey) {
        priceKey = pricingKey
      }

      if (priceKey) {
        const result = (getPrice && layoutId) ? await jaycoClient.query({
          query: GET_MODEL_DATA,
          variables: {
            id: layoutId
          }
        }) : {};
        const priceVal = get(result, `data.getModel.${priceKey}`, null);
        setApiPrice(priceVal ? Math.ceil(priceVal) : null);
      }

      setLoading(false);
    }
    
    getModelPrice();

    return () => {
      jaycoClient.stop();
      setLoading(false);
    };

  }, [layoutId, pricingKey]);

  return (
    <Container>
      {/* {!hideImgMobile || theme.isWidthUp('md', props.width) && */}
      <ImgContainer>
        <NextLink href={uri}>
          
            <RespImg
              {...image}
              type="png"
            />
       
        </NextLink>
      </ImgContainer>
      {/* } */}
      <Content>
        <div data-equalize>
        <Text variant="h6" uppercase colour="vividBlue" align="left">{title}</Text>
        </div>
        {filters &&
        <Filters>
          {/* {filters.range &&
            <FilterItem>
              <Dropdown
                {...filters.range}
                onChange={(e) => onChange('range', e)}
              />
            </FilterItem>
          }
          {filters.series &&
            <FilterItem>
              <Dropdown
                {...filters.series}
                onChange={(e) => onChange('series', e)}
              />
            </FilterItem>
          } */}
          {/* <Grid container spacing={0} direction={'row'} justifyContent={'space-between'} align={'left'}> */}
            {/* {filters.spec &&
              <Grid size={{xs: 12, md: 12}}>
                <FilterItem paddingRight>
                  <Dropdown
                    {...filters.spec}
                    onChange={(e) => onChange('spec', e)}
                  />
                </FilterItem>
              </Grid>
            } */}
          {filters.size &&
            <Grid
              size={{
                xs: 12,
                md: 12
              }}>
              <FilterItem>
                <Dropdown
                  {...filters.size}
                  neverNative={true}
                  disableScroll={false}
                  onChange={(e) => onChange('size', e)}
                />
              </FilterItem>
            </Grid>
          }
          {/* </Grid> */}
        </Filters>
        }

      </Content>
      <SleepKey 
        standard={sleepsStandard}
        optional={sleepsOptional}
        title="Sleeps:"
        showKey={true}
      />
      <Content padding={1}>
        <Footer>
        
          {/* {(price || apiPrice || loading) && */}
          {process.env.SHOW_PRICING &&
            <Price opacity={loading ? 1 : 0}>
              <Text variant="h3" uppercase colour="charcoal" spacing={0}>
                {getPrice === true ?
                <>
                  ${apiPrice || price ? toPrice(apiPrice ? apiPrice : price) : '--,---'}<span>*</span>
                </>
                :
                <>
                </>
                }
              </Text>
            </Price>
          }
          {/* } */}
          {
          <Typography>
            <Buttons>
              <ButtonItem onClick={onSave}>
                <Links secondary svg={saved ? HeartFilledSvg : HeartSvg} href={undefined}>
                  {saved ? 'Saved' : 'Save'}
                </Links>
              </ButtonItem>
            </Buttons>
          </Typography>
          }
        </Footer>
      </Content>
    </Container>
  );
}

CaravanFilter.propTypes = {
  title: propTypes.string,
  image: propTypes.object,
  filters: propTypes.object,
  sleepsStandard: propTypes.any,
  sleepsOptional: propTypes.any,
  price: propTypes.any,
  saved: propTypes.bool,
  onClear: propTypes.func,
  onSave: propTypes.func,
  onChange: propTypes.func,
  getPrice: propTypes.bool,
  layoutId: propTypes.string,
  hideImgMobile: propTypes.bool
}

export default (CaravanFilter);
